import { generatedApi } from '../axilon-v2-api.generated'

const applyExtraOptionsOverrides = (api: typeof generatedApi) =>
  api.enhanceEndpoints({
    endpoints: {
      login: { extraOptions: { public: true } },
      getAuthenticationConfig: { extraOptions: { public: true } },
      checkMfa: { extraOptions: { public: true } },
      accountRecovery: { extraOptions: { public: true } },
      sessionOidcAuthentication: { extraOptions: { public: true } },
      // Phone-side pairing routes authenticate with the pairing secret, not a
      // Bearer token. The web app never calls them.
      claimDevicePairing: { extraOptions: { public: true } },
      confirmDevicePairing: { extraOptions: { public: true } },
      rejectDevicePairing: { extraOptions: { public: true } }
    }
  })

export default applyExtraOptionsOverrides
